export default __webpack_public_path__ + "static/t1-6f9ef6b9b9d8a31de494f2623be897c3.jpg";